import React from 'react';
import './LoginPage.css';

function PendingApproval({ status, onLogout }) {
  const isDenied = status === 'denied';

  return (
    <div className="login-page">

      <div className="login-background">
        <div className="grain-overlay"></div>
        <div className="corporate-glow"></div>
        <div className="grain-line line-1"></div>
        <div className="grain-line line-2"></div>
        <div className="grain-line line-3"></div>
      </div>

      <div className="grain-silhouettes">
        <div className="silhouette silhouette-1"></div>
        <div className="silhouette silhouette-2"></div>
        <div className="silhouette silhouette-3"></div>
        <div className="silhouette silhouette-4"></div>
      </div>

      <div className="login-container">

        <div className="login-logo">
          <div className="logo-container">
            <h1 className="dilex-wordmark">dilex</h1>
            <div className="grain-accent-line"></div>
          </div>
          <p className="login-subtitle">Operations Management System</p>
        </div>

        <div className="status-card">
          <div className="status-icon">{isDenied ? '\u{1F6AB}' : '\u23F3'}</div>
          <h2 className="status-title">
            {isDenied ? 'Access Request Denied' : 'Awaiting Approval'}
          </h2>
          <p className="status-message">
            {isDenied
              ? 'Your request for access was not approved. If you believe this is a mistake, contact your administrator.'
              : 'Your access request is still waiting for an administrator to review it. Please check back shortly, or contact your administrator if this is taking longer than expected.'}
          </p>
          <button type="button" className="secondary-button" onClick={onLogout}>
            Log Out
          </button>
        </div>

        <div className="login-footer">
          <div className="footer-divider"></div>
          <div className="footer-micro">
            <span className="version-text">Powered by DILEX Holdings</span>
          </div>
        </div>

      </div>
    </div>
  );
}

export default PendingApproval;
